import React, {useState} from "react";
import {
    Box,
    Dialog,
    DialogContent,
    DialogTitle,
    DialogActions,
    Button,
    Typography,
    IconButton,
    useMediaQuery
} from "@mui/material";
import { Close as CloseIcon, PhoneAndroid as PhoneIcon } from "@mui/icons-material";
import LoginLeft from "./Left/LoginLeft";
import LoginRight from "./Right/LoginRight";

const LoginPageV2 = (props) => {
    const [showOTP, setShowOTP] = useState(false);
    const [showMobileOTPWarning, setShowMobileOTPWarning] = useState(false);
    const isMobile = useMediaQuery("(max-width:768px)");

    const handleShowOtp = () => {
        if (isMobile) {
            setShowMobileOTPWarning(true);
        } else {
            setShowOTP(true);
        }
    };

    const handleCloseMobileWarning = () => {
        setShowMobileOTPWarning(false);
    };

    return (
        <>
            <Box
                sx={{
                    height: "100vh",
                    backgroundColor: "#FBF4F0",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    padding: isMobile ? 2 : 0,
                }}
            >
                <Box
                    sx={{
                        maxWidth: isMobile ? "100%" : "900px",
                        width: "100%",
                        backgroundColor: "#E3F2FD",
                        display: "flex",
                        borderRadius: isMobile ? "12px" : "16px",
                        overflow: "hidden",
                        boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.1)",
                        zoom: isMobile ? "100%" : "90%",
                        minHeight: isMobile ? "auto" : "600px",
                        flexDirection: isMobile ? "column" : "row",
                    }}
                >
                    {/* Left Panel - Hidden on mobile and during 2FA */}
                    {!isMobile && !showOTP && <LoginLeft otp={showOTP}/>}

                    {/* Right Panel */}
                    <Box
                        sx={{
                            flex: 1,
                            display: "flex",
                            flexDirection: "column",
                            width: isMobile ? "100%" : (showOTP ? "100%" : "50%"),
                        }}
                    >
                        <LoginRight
                            refresh={() => props.refresh(true)}
                            fn={() => props.fn()}
                            showOtp={handleShowOtp}
                            isMobile={isMobile}
                        />
                    </Box>
                </Box>
            </Box>

            {/* Mobile 2FA Warning Dialog */}
            <Dialog
                open={showMobileOTPWarning}
                onClose={handleCloseMobileWarning}
                maxWidth="sm"
                fullWidth
                PaperProps={{
                    sx: {
                        borderRadius: "16px",
                        margin: 2,
                    }
                }}
            >
                <DialogTitle
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 2,
                        pb: 1
                    }}
                >
                    <PhoneIcon color="warning" />
                    <Typography variant="h6" component="span">
                        Mobile Login Restriction
                    </Typography>
                    <IconButton
                        onClick={handleCloseMobileWarning}
                        sx={{ ml: "auto" }}
                        size="small"
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>

                <DialogContent>
                    <Typography variant="body1" sx={{ mb: 2 }}>
                        Two-Factor Authentication (2FA) accounts cannot be accessed from mobile devices for security reasons.
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                        Please use a desktop or laptop computer to log in with your 2FA-enabled account.
                    </Typography>
                </DialogContent>

                <DialogActions sx={{ px: 3, pb: 3 }}>
                    <Button
                        onClick={handleCloseMobileWarning}
                        variant="contained"
                        fullWidth
                        sx={{
                            borderRadius: "8px",
                            textTransform: "none",
                            py: 1.5,
                        }}
                    >
                        I Understand
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default LoginPageV2;